export const FeatureStorageQueryStringParamsAndStorageKey = {
  setPreview: 'preview-enabled-features',
  addPanelFlights: 'cux-add-support-panel-flights',
  removePanelFlights: 'cux-remove-support-panel-flights',
};

export const BrowserStorageKeys = {
  panelFlight: 'cux-support-panel-flights',
  supportWorkspace: 'supportWorkspaceFlight',
  publicDeepLinkInfo: 'support-public-deepLinkInfo',
  panelDeepLinkInfo: 'he-ext-deepLinkInfo',
  deepLinkToAIAssistant: 'he-ext-deepLinkToAIAssistantInfo',
};

export const QueryStringParams = {
  supportPanel: 'supportPanel',
  setSupportFlight: 'setSupportFlight',
  tenantId: 'tid',
  mpnId: 'mpnid',
};
